// extracted by mini-css-extract-plugin
module.exports = {"card":"Asset-module__card___3HE1i","image":"Asset-module__image___1lNXa","details":"Asset-module__details___2r-hX"};